module.exports = __webpack_public_path__ + "img/DAY5-1.3f90414c.jpg";